module.exports = __webpack_public_path__ + "eecfbab0801fe7e36427d169cb96f6a5.svg";